import { deleteCookie, getCookie, setCookie } from 'cookies-next';
import { OptionsType } from 'cookies-next/lib/types';
import { useState } from 'react';

export function useCookie(key: string, defaultValue?: string) {
  const currentValue = getCookie(key)?.toString() ?? defaultValue;

  const [value, setValue] = useState(currentValue);

  const handleSetCookie = (value: string | undefined, options?: OptionsType) => {
    setValue(value);

    if (value == null) {
      deleteCookie(key);
    } else {
      setCookie(key, value, options);
    }
  };

  return {
    cookie: value,
    setCookie: handleSetCookie,
  };
}
